/** After a payment stage is marked complete, refresh accounts / closed-deal views. */
export function invalidateAccountsAfterStageChange(queryClient) {
  if (!queryClient) return;
  queryClient.invalidateQueries({ queryKey: ['orderActivities'] });
  queryClient.invalidateQueries({ queryKey: ['stageUnlock'] });
  queryClient.invalidateQueries({ queryKey: ['closedDeals'] });
  queryClient.invalidateQueries({ queryKey: ['leadById'] });
  queryClient.invalidateQueries({ queryKey: ['deals'] });
  queryClient.invalidateQueries({ queryKey: ['dealReconcile'] });
  queryClient.invalidateQueries({ queryKey: ['dealPaymentHistory'] });
  queryClient.invalidateQueries({ queryKey: ['priorities'] });
  queryClient.invalidateQueries({ queryKey: ['prioritiesGenerateInvoiceModal'] });
}
